import { render, staticRenderFns } from "./GameDialog.vue?vue&type=template&id=97249ae6&scoped=true&"
import script from "./GameDialog.vue?vue&type=script&lang=js&"
export * from "./GameDialog.vue?vue&type=script&lang=js&"
import style0 from "./GameDialog.vue?vue&type=style&index=0&id=97249ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97249ae6",
  null
  
)

export default component.exports